import {useState} from 'react';
import {useMutation, useQueryClient} from 'react-query';
import {STORAGE_OBJECTS_QUERY_KEY} from '../init/constants';
import {APIClient} from '../backend/ApiClient';
import {UploadFileDTO} from '../models/dto/UploadFileDTO';

export const useUploadFile = (setProgress: (progress: number) => void) => {
    const queryClient = useQueryClient();
    const apiClient = APIClient();

    const [uploadFileModeActive, setUploadFileModeActive] = useState<boolean>(false);

    const uploadFileApiCall = (uploadFileDTO: UploadFileDTO) => {
        return apiClient.uploadFile(
            uploadFileDTO.file,
            setProgress,
            uploadFileDTO.executeFileUpload,
            uploadFileDTO.thumbnail,
            uploadFileDTO.item
        );
    };

    const {mutateAsync: createUploadFileMutation, isLoading} = useMutation(uploadFileApiCall, {
        onSuccess: () => {
            queryClient.invalidateQueries(STORAGE_OBJECTS_QUERY_KEY);
        }
    });

    const uploadFile = (uploadFileDTO: UploadFileDTO, addMore: boolean) => {
        return createUploadFileMutation(uploadFileDTO, {
            onSuccess: () => {
                setUploadFileModeActive(false);
                if (addMore) {
                    setUploadFileModeActive(true);
                }
            }
        });
    };

    return {uploadFileModeActive, setUploadFileModeActive, uploadFile, isLoading};
};
